import React from 'react'
import { Paper, Typography, makeStyles } from '@material-ui/core'
import useTranslate from '../../../../../i18n/useTranslate'
import { ItemListType } from '../../../../../services/web/types/responseWebServiceTypes'
import { statusColorConstant } from '../../../../../constants/constants'

type Props = { data: ItemListType }

const SUBMITTED_STATUS_LIST = [
    statusColorConstant.status1,
    statusColorConstant.status2,
    statusColorConstant.status3,
    statusColorConstant.status4,
    statusColorConstant.status5,
    statusColorConstant.status6,
    statusColorConstant.status7,
    statusColorConstant.status8,
    statusColorConstant.status9,
    statusColorConstant.status10,
    statusColorConstant.status11,
    statusColorConstant.status12,
    statusColorConstant.status14,
    statusColorConstant.status17,
    statusColorConstant.status18,
    statusColorConstant.resultOfConsideration,
    statusColorConstant.noScope,
    statusColorConstant.terminate,
    statusColorConstant.withdraw,
    statusColorConstant.proceedingMemoMessage,
    statusColorConstant.waitingEditProject,
]

const SubmittedBg = SUBMITTED_STATUS_LIST.reduce<Record<number, string>>((acc, s) => {
    if (acc[s.statusID] == null) acc[s.statusID] = s.backgroundColor
    return acc
}, {})

const getSubmittedBgColorById = (id?: number | null) => (id != null ? SubmittedBg[id] : undefined) ?? '#999'

function SubmittedStatusText({ data }: Props) {
    const translate = useTranslate()
    const isTH = translate.languageStore.currentLanguage === translate.languageKey.th

    const text = isTH ? (data.submittedStatus_th ?? '-') : (data.submittedStatus_en ?? '-')
    const color = React.useMemo(() => getSubmittedBgColorById(data.submittedStatusID), [data.submittedStatusID])

    const classes = useStyles({ color })

    return (
        <Paper variant="outlined" className={classes.root}>
            <Typography variant="body1" noWrap style={{ fontWeight: 700 }}>
                {text}
            </Typography>
        </Paper>
    )
}

const useStyles = makeStyles<any, { color: string }>(() => ({
    root: (p) => ({
        padding: '2px 10px',
        borderRadius: 8,
        border: '1px solid transparent',
        textAlign: 'center',
        display: 'inline-flex',
        alignItems: 'center',
        color: p.color,
        fontWeight: 700,
    }),
}))

export default SubmittedStatusText
